import React from "react";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../components/LoadingSpinner";

function LoadingTablePage({ loading, title }) {
  const { t } = useTranslation();
  if (!loading) {
    return null;
  }

  const text = title ? t("common.loadingEntity", { name: title }) : t("common.loading");

  return (
    <div className="flex h-full w-full items-center justify-center px-4 pointer-events-none">
      <LoadingSpinner text={text} />
    </div>
  );
}

export default LoadingTablePage;
